export const getEnrolmentEntryUrl = () => {
  if (process.env.VUE_APP_LINKED_TO_MARKETING_SITE === "true") {
    return process.env.VUE_APP_QUOTE_URL_MARKETING_PREFIX + "/quote/"
  }
  return "/quote/"
}
